import React, { useEffect } from "react";
import { Briefcase } from "lucide-react";
import ServiceApi from "../../api/serviceApi";
import { useAuthUser } from "../../hooks/useAuthUser";
import { useBilingualMasterData } from "../../hooks/useBilingualMasterData";
import BilingualMasterPage from "../../components/masterData/BilingualMasterPage";

const serviceApi = new ServiceApi();

const Service = () => {
  const userData = useAuthUser();
  const {
    isError,
    validated,
    cp,
    icon_id,
    list: serviceDataList,
    show,
    LoadData,
    deleteAlert,
    matches,
    showConfirmationModal,
    setShowConfirmationModal,
    data,
    handleClose,
    handleCloseAlert,
    handleShow,
    handleChanges,
    handleSubmit,
    handleConfirmSubmit,
    CollectData,
    DeleteData,
    SearchData,
    fetchList,
    clearfield,
    searchKey,
  } = useBilingualMasterData({
    emptyData: { service: "", spanishService: "" },
    englishField: "service",
    spanishField: "spanishService",
    api: {
      add: (payload) => serviceApi.addService(payload),
      update: (payload, id) => serviceApi.updateService(payload, id),
      remove: (payload, id) => serviceApi.deleteService(payload, id),
      list: () => serviceApi.getAllServiceList({} as any),
      search: (payload, key) => serviceApi.searchKey(payload, key),
    },
    sortList: (rows) =>
      [...rows].sort((a, b) => a.service.localeCompare(b.service)),
    setDataOnShow: true,
    clearBeforeDelete: true,
  });

  useEffect(() => {
    if (searchKey) {
      SearchData({ target: { value: searchKey } });
    } else {
      fetchList();
    }
  }, []);

  return (
    <BilingualMasterPage
      isAdmin={Boolean(userData && userData.userRole === "ADMIN")}
      formTitle="Add Service Title"
      listTitle="Service Titles"
      listSubtitle="Manage bilingual service names used on retreat rosters."
      formIcon={<Briefcase size={20} color="#285d8f" />}
      listIcon={<Briefcase size={20} color="#285d8f" />}
      englishLabel="Service Title"
      englishPlaceholder="Enter New Service Title"
      englishRequiredMessage="Service Title is required!"
      englishField="service"
      spanishLabel="Spanish Service Title"
      spanishPlaceholder="Enter Spanish Service Title"
      spanishField="spanishService"
      englishColumnName="Service Title"
      spanishColumnName="Spanish Service Title"
      dataKey="service"
      deleteTitle="Service Detail"
      deleteDetailLabel="Service"
      deleteAlertHeader="You are not able to delete this Service"
      deleteAlertMessage={
        <div>
          <h4>Retreat Roster(s) are added for this Service.</h4>{" "}
          <h5>
            If you want to delete this Service, first please change the Service
            for Retreat Rosters.
          </h5>
        </div>
      }
      isError={isError}
      validated={validated}
      cp={cp}
      icon_id={icon_id}
      list={serviceDataList}
      show={show}
      LoadData={LoadData}
      deleteAlert={deleteAlert}
      matches={matches}
      showConfirmationModal={showConfirmationModal}
      setShowConfirmationModal={setShowConfirmationModal}
      data={data}
      handleClose={handleClose}
      handleCloseAlert={handleCloseAlert}
      handleShow={handleShow}
      handleChanges={handleChanges}
      handleSubmit={handleSubmit}
      handleConfirmSubmit={handleConfirmSubmit}
      CollectData={CollectData}
      DeleteData={DeleteData}
      SearchData={SearchData}
      clearfield={clearfield}
      searchValue={searchKey}
    />
  );
};
export default Service;
